import { render, staticRenderFns } from "./CustomerOrdersEdit.vue?vue&type=template&id=68197065&scoped=true&"
import script from "./CustomerOrdersEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerOrdersEdit.vue?vue&type=style&index=1&id=68197065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68197065",
  null
  
)

export default component.exports